
import { supabase } from '@/integrations/supabase/client';

export interface SupabaseUser {
  id: string;
  username?: string;
  first_name?: string;
  last_name?: string;
  role: string;
  profile_photo_url?: string;
}

const normalizeUserSearchQuery = (query: string) => query.trim().replace(/^@+/, '').toLowerCase();

export const supabaseUserService = {
  async searchUsers(query: string): Promise<SupabaseUser[]> {
    console.log('=== SUPABASE USER SERVICE SEARCH ===');
    console.log('Search query:', query);
    
    if (!query || query.trim().length < 1) {
      console.log('Empty query, returning empty array');
      return [];
    }

    const cleanQuery = normalizeUserSearchQuery(query);
    console.log('Clean query:', cleanQuery);

    if (!cleanQuery) {
      console.log('Normalized query is empty, returning empty array');
      return [];
    }

    try {
      // Search with a more robust query
      const { data, error } = await supabase
        .from('profiles')
        .select('id, username, first_name, last_name, role, profile_photo_url')
        .or(`username.ilike.%${cleanQuery}%,first_name.ilike.%${cleanQuery}%,last_name.ilike.%${cleanQuery}%`)
        .limit(50);

      if (error) {
        console.error('Error searching Supabase users:', error);
        return [];
      }

      console.log('Supabase users found:', data?.length || 0);
      console.log('Raw data:', data);

      return data || [];
    } catch (error) {
      console.error('Exception in searchUsers:', error);
      return [];
    }
  },

  async getAllUsers(): Promise<SupabaseUser[]> {
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('id, username, first_name, last_name, role, profile_photo_url')
        .not('id', 'is', null)
        .limit(100); // Reduced limit for faster initial load

      if (error) {
        console.error('Error fetching all Supabase users:', error);
        return [];
      }

      return data || [];
    } catch (error) {
      console.error('Exception in getAllUsers:', error);
      return [];
    }
  }
};
